import {Check} from "./type-checking";


export class CardExpiration {

    constructor(public readonly month: number,
                public readonly year: number) {
    }

    public static parse(value: string): CardExpiration | null {

        if (!value) {
            return null;
        }

        const parts = value.split('/');
        if (parts.length !== 2) {
            return null;
        }

        const month = parseInt(parts[0]);
        const year = parseInt(parts[1]);
        if (!Check.isNumber(month) || !Check.isNumber(year)) {
            return null;
        }

        return new CardExpiration(month, year);
    }

    toString() {
        const yearLast2Digits = this.year.toString().slice(-2);
        return this.month.toString().padStart(2, '0') + '/' + yearLast2Digits;
    }


    isInThePast(): boolean {
        if(this.year < new Date().getFullYear()) {
            return true;
        }
        return (
            this.year === new Date().getFullYear() &&
            this.month < new Date().getMonth() + 1
        )
    }

}